<div class="senior-onboarding-info">
  <div class="info-box">
    <mat-icon class="info-icon">info</mat-icon>
    <p class="info-text">
      <span *ngIf="!isAssurant else elseTemplate">You can use <strong>either your email</strong> or <strong>property code</strong> to continue.</span>
      <ng-template #elseTemplate>Email is required to continue to the next step</ng-template>
    </p>
  </div>
</div>
